import React, { useContext, useEffect } from "react";
import { AuthContext } from "../Contexts/AuthContext";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import WebsiteRoutes from "./WebsiteRoutes";
import PageNotFound from "../layout/PageNotFound";

/***
 * Criar aqui uma verificação para saber se  usuário está logado veirificando  o token no local storage
 * 
 */

const AppRoutes = () => {
    const HASH_COOKIE = process.env.REACT_APP_COOKIE_HASH;

    const [cookies, setCookie, removeCookie] = useCookies([HASH_COOKIE], { doNotParse: true });

    const { auth, setAuth, user } = useContext(AuthContext)
    const url = window.location.href.split('/')
 //   console.log(url)

    const PrivateRoutesAuth = () => {
        //console.log(localStorage.getItem('tk_hsp')) 
        //  if (localStorage.getItem('tk_hsp') !== 'null' && localStorage.getItem('tk_hsp') !== '') {
        
            if (url[3] != 'admin' && url[3] != 'login' && url[3] != '' ) {
                return <WebsiteRoutes />;
            } else {

                if (cookies[HASH_COOKIE] != undefined) {

                    setAuth(true);
                    return <PrivateRoutes />
                } else {
                    setAuth(false);
                    return <PublicRoutes />
                }
            }
    }


    return PrivateRoutesAuth();


}

export default AppRoutes;